import React from 'react';
import { ADDON_TYPE } from '@shootsta/common-domain-data';
import { getCostForAddon, getCustomCostForAddon } from '../utils';

const REVIEW_LABEL = 'Voice Over Artist';

const VOICE_OVER_ARTIST_ICON = 'voiceover';

export default function () {
  return ({
    billingEntityCode,
    addonsCosts,
    includedAddons,
    customAddonCosts





  }) => {
    const zeroCost = getCostForAddon({ billingEntityCode, costs: null });
    const cost = includedAddons.includes('VOICE_OVER_ARTIST') ?
    zeroCost :
    getCostForAddon({ costs: addonsCosts.VOICE_OVER_ARTIST.costs, billingEntityCode });

    const addonCost = customAddonCosts && customAddonCosts.length ? getCustomCostForAddon({
      addonType: ADDON_TYPE.VOICE_OVER_ARTIST,
      billingEntityCode,
      customAddonCosts
    }) : cost;

    return [
    {
      reviewLabel: REVIEW_LABEL,
      label: 'No',
      value: false,
      suffix: <span>{zeroCost}</span>,
      icon: VOICE_OVER_ARTIST_ICON,
      cost: zeroCost
    },
    {
      reviewLabel: REVIEW_LABEL,
      label: 'Yes',
      value: true,
      suffix: <span>{addonCost}</span>,
      icon: VOICE_OVER_ARTIST_ICON,
      cost: addonCost
    }];

  };
}